import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const BreadcrumbContainer = styled.nav`
  padding: 1rem 2rem;
  background: white;
  border-bottom: 1px solid rgba(37, 99, 235, 0.1);
`;

const BreadcrumbList = styled.ol`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  max-width: 1200px;
  margin: 0 auto;
`;

const BreadcrumbItem = styled.li`
  display: flex;
  align-items: center;
  color: #64748b;
  font-size: 0.875rem;

  &:not(:last-child) {
    margin-right: 0.5rem;

    &:after {
      content: '/';
      margin-left: 0.5rem;
      color: #94a3b8;
    }
  }

  &:last-child {
    color: #1e293b;
    font-weight: 500;
  }
`;

const BreadcrumbLink = styled(Link)`
  color: inherit;
  text-decoration: none;
  transition: color 0.2s ease;

  &:hover {
    color: #2563eb;
  }
`;

const Breadcrumbs = ({ items }) => {
  return (
    <BreadcrumbContainer>
      <BreadcrumbList>
        <BreadcrumbItem>
          <BreadcrumbLink to="/">Home</BreadcrumbLink>
        </BreadcrumbItem>
        {items.map((item, index) => (
          <BreadcrumbItem key={index}>
            {index === items.length - 1 ? (
              <span>{item.label}</span>
            ) : (
              <BreadcrumbLink to={item.path}>{item.label}</BreadcrumbLink>
            )}
          </BreadcrumbItem>
        ))}
      </BreadcrumbList>
    </BreadcrumbContainer>
  );
};

export default Breadcrumbs;